import React, { useCallback } from 'react';
import { motion } from 'framer-motion';

import useAnimate from '../ui/Motion';

import Reveal from '../ui/Reveal';
import SectionHead from './SectionHead';
import { advantages } from '../data/site';

const EASE = [0.16, 1, 0.3, 1];

export default function Bento({
    eyebrow = 'Why us',
    title,
    lead,
    items = advantages,
    outro,
    id,
    cols = 4
}) {
    const reduced = !useAnimate();

    // Feeds the pointer position to the card so its glow follows the cursor.
    const trackPointer = useCallback(event => {
        const rect = event.currentTarget.getBoundingClientRect();
        event.currentTarget.style.setProperty('--mx', `${event.clientX - rect.left}px`);
        event.currentTarget.style.setProperty('--my', `${event.clientY - rect.top}px`);
    }, []);

    return (
        <section className="section section--raised" id={id}>
            <div className="shell">
                <SectionHead eyebrow={eyebrow} title={title} lead={lead}
                    className="bento-head" />

                <ul className="bento" style={{ '--cols': cols, marginTop: 'clamp(2.5rem, 6vw, 4rem)' }}>
                    {items.map((item, i) => (
                        <motion.li
                            className="bento__card"
                            key={item.title}
                            onPointerMove={trackPointer}
                            initial={reduced ? false : { opacity: 0, y: 28 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.25 }}
                            transition={{ duration: 0.75, delay: (i % cols) * 0.07, ease: EASE }}
                        >
                            <span className="bento__num">{String(i + 1).padStart(2, '0')}</span>
                            <h3 className="bento__title">{item.title}</h3>
                            <p className="bento__copy">{item.body}</p>
                        </motion.li>
                    ))}
                </ul>

                {outro && (
                    <Reveal delay={0.1} className="bento__outro">
                        <p className="t-lead">{outro}</p>
                    </Reveal>
                )}
            </div>
        </section>
    );
}
